import { Skeleton } from "primereact/skeleton";

const RenderLoading = (itemsNumber:number) => {
    const options = [];
  
    for (let i = 0; i <= itemsNumber; i++) {
      options.push( <Skeleton className="m-3" />);
    }
    return <>{options}</>;
  };



  export default RenderLoading;